import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

/**
 * Generates message for Schema.org section
 * @param {Object} counts - The counts object from API
 * @returns {string|null} - Message for empty state or null if data exists
 */
const generateMessage = (counts) => {
  if (!counts || Object.keys(counts).length === 0) {
    return "We didn't detect any schema.org items on your webpage";
  }
  return null;
};

/**
 * Builds table data from counts object
 * @param {Object} counts - Object with type counts like { "WebPage": 1 }
 * @returns {Array} - Array of table row objects
 */
const buildSchemaTable = (counts) => {
  if (!counts || Object.keys(counts).length === 0) {
    return [];
  }

  return Object.entries(counts).map(([type, count]) => ({
    type: type || '',
    count: count ?? 0,
  }));
};

/**
 * Transforms the schema_org criteria from WooRank API response
 * @param {Object} schemaOrgCriteria - The schema_org criteria object from the API
 * @returns {Object} - Transformed schema.org data for React components
 */
export const transformSchemaOrg = (schemaOrgCriteria) => {
  // Handle missing criteria - use 'neutral' status (maps to 'info' icon)
  if (!schemaOrgCriteria) {
    return {
      status: getStatus('neutral'),
      iconType: getIconType('neutral'),
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: "We didn't detect any schema.org items on your webpage",
      data: null,
    };
  }

  const data = schemaOrgCriteria?.data || {};
  const wooRankStatus = schemaOrgCriteria?.status || 'neutral';
  const importance = schemaOrgCriteria?.importance || 0;
  const solvability = schemaOrgCriteria?.solvability || 0;

  const counts = data?.counts || {};
  const items = data?.items || [];

  const schemaTable = buildSchemaTable(counts);
  const isEmpty = schemaTable.length === 0;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: generateMessage(counts),
    data: isEmpty ? null : {
      schemaTable,
      items,
    },
  };
};

export default transformSchemaOrg;

